/* The Ship's Store - feature-led unit page builder.
   Rebuilds each collection section as a magazine 'article': a large lead image beside
   a heading + a grid of thumbnails + a 'view all' link. Untitled continuation blocks are
   folded in as extra cards. For collection (cruise) features, 'View all' expands in place
   to reveal a card for EVERY cruise instead of navigating to the featured one. */
(function () {
  var OWN_THUMBS = 6;       // thumbnails shown beside the lead before expanding
  function bigger(src) {
    if (!src) return src;
    try {
      if (src.indexOf('width=') > -1) return src.replace(/width=\d+/, 'width=1000');
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
    } catch (e) { return src; }
  }
  function cardData(li) {
    var a = li.querySelector('a[href]');
    var img = li.querySelector('img');
    var titleEl = li.querySelector('.card__heading, .full-unstyled-link, h3, .card-information__text, .card-collection-info__heading');
    var src = img ? ((img.getAttribute('src') || img.currentSrc || '').trim()) : '';
    var title = '';
    var year = '';
    if (titleEl) {
      var yEl = titleEl.querySelector('.card__collection-year');
      if (yEl) {
        year = yEl.textContent.trim();
        var clone = titleEl.cloneNode(true);
        var cy = clone.querySelector('.card__collection-year');
        if (cy && cy.parentNode) { cy.parentNode.removeChild(cy); }
        title = clone.textContent.trim();
      } else {
        title = titleEl.textContent.trim();
      }
    } else if (a) {
      title = a.textContent.trim();
    }
    return {
      href: a ? a.getAttribute('href') : null,
      src: src,
      alt: img ? (img.getAttribute('alt') || '').replace(/\"/g, '') : '',
      title: title,
      year: year
    };
  }
  function thumbLi(c) {
    var li = document.createElement('li');
    li.innerHTML = '<a href=\"' + (c.href || '#') + '\">'
      + '<div class=\"mag-feature__thumb-img\"><img src=\"' + c.src + '\" alt=\"' + c.alt + '\"></div>'
      + '<p class=\"mag-feature__thumb-title\">' + c.title + '</p>'
      + (c.year ? '<p class=\"mag-feature__thumb-year\">' + c.year + '</p>' : '')
      + '</a>';
    return li;
  }
  function build(info, idx, flip) {
    var cards = info.cards;
    var lead = cards[0];
    var thumbs = cards.slice(1);
    var initial = thumbs.slice(0, OWN_THUMBS);
    var rest = thumbs.slice(OWN_THUMBS);
    var wrap = document.createElement('div');
    wrap.className = 'mag-feature' + (idx === 0 ? ' mag-feature--first' : '') + (flip ? ' mag-feature--flip' : '');
    var viewall = '';
    if (info.isCollections && rest.length) {
      viewall = '<a class=\"mag-feature__viewall\" href=\"#\" data-mag-expand=\"1\">View all &rarr;</a>';
    } else if (!info.isCollections && info.url) {
      viewall = '<a class=\"mag-feature__viewall\" href=\"' + info.url + '\">View all &rarr;</a>';
    }
    wrap.innerHTML =
      '<div class=\"mag-feature__inner\">'
      + '<a class=\"mag-feature__lead\" href=\"' + (info.url || lead.href || '#') + '\">'
      + '<img src=\"' + bigger(lead.src) + '\" alt=\"' + lead.alt + '\"></a>'
      + '<div class=\"mag-feature__body\">'
      + '<div class=\"mag-feature__bar\"></div>'
      + '<h2 class=\"mag-feature__title\">' + info.title + '</h2>'
      + (info.count ? '<p class=\"mag-feature__cap\">' + info.count + '</p>' : '')
      + '<ul class=\"mag-feature__thumbs\"></ul>'
      + viewall
      + '</div></div>';
    var ul = wrap.querySelector('.mag-feature__thumbs');
    initial.forEach(function (c) { ul.appendChild(thumbLi(c)); });
    if (info.isCollections && rest.length) {
      var btn = wrap.querySelector('[data-mag-expand]');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        rest.forEach(function (c) { ul.appendChild(thumbLi(c)); });
        if (btn.parentNode) { btn.parentNode.removeChild(btn); }
      });
    }
    return { el: wrap, ul: ul };
  }
  function headingText(section) {
    var h = section.querySelector('.title__heading, .title h2, .title h1, h2.title__heading');
    return h ? h.textContent.trim() : '';
  }
  function collectionUrl(section) {
    var a = section.querySelector('a[href*=\"/collections/\"]');
    return a ? a.getAttribute('href') : null;
  }
  function sectionInfo(section) {
    var isFC = !!section.querySelector('.featured-collection__wrapper-products, ul.product-grid');
    var cardSel = isFC ? 'li.grid__item' : 'li.collection-list__item';
    var lis = section.querySelectorAll(cardSel);
    if (!lis.length) lis = section.querySelectorAll('li');
    if (!lis.length) return null;
    var cards = Array.prototype.slice.call(lis).map(cardData).filter(function (c) { return c.src; });
    if (!cards.length) return null;
    return {
      cards: cards,
      title: headingText(section),
      url: collectionUrl(section),
      isCollections: !isFC,
      count: cards.length + (isFC ? ' products' : ' collections')
    };
  }
  function run() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section')).filter(function (s) {
      return s.querySelector('.featured-collection__wrapper-products, .section-collection-list .collection-list, ul.product-grid, ul.collection-list');
    });
    var idx = 0;
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var info = sectionInfo(section);
      if (!info) continue;
      if (info.title) {
        var j = i + 1;
        while (j < sections.length) {
          var nInfo = sectionInfo(sections[j]);
          if (nInfo && !nInfo.title) {
            info.cards = info.cards.concat(nInfo.cards);
            sections[j].style.display = 'none';
            j++;
          } else { break; }
        }
        info.count = info.cards.length + (info.isCollections ? ' collections' : ' products');
        var built = build(info, idx, idx % 2 === 1);
        var host = section.querySelector('.featured-collection, .section-collection-list > div, .section') || section;
        host.innerHTML = '';
        host.appendChild(built.el);
        idx++;
        i = j - 1;
      }
    }
  }
  if (document.readyState !== 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }
})();
